import styled from '@emotion/styled';

export const StyledContainer = styled('a')(() => ({
  height: 80,
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '8px 32px',
  borderTop: `1px solid #dbddde`,
}));

export const StyledLink = styled('a')(() => ({
  textDecoration: 'none',
  color: '#4e4e4e',
  fontWeight: 'bold',
  fontSize: 14,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
}));

export const StyledAction = styled('div')(() => ({
  color: '#4e4e4e',
  fontWeight: 'bold',
  fontSize: 14,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
}));
